import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  data: [],
  orderData: [],
  zone: [],
};
const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    setTableData: (state, action) => {
      state.data = action.payload;
    },
    setTableOrderData: (state, action) => {
      state.orderData = action.payload;
    },
    setTableZone: (state, action) => {
      state.zone = action.payload;
    },
    clearTableData: (state) => {
      state.data = [];
    },
    clearTableOrder: (state) => {
      state.orderData = [];
    },
    clearTableZone: (state) => {
      state.zone = [];
    },
  },
});
export const { setTableData, clearTableData, setTableOrderData, clearTableOrder, setTableZone, clearTableZone } = tableSlice.actions;
export default tableSlice.reducer;
